import React from 'react'
import {motion} from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const {FiHeart,FiExternalLink,FiShield,FiFileText,FiSettings,FiMail,FiBot,FiCode}=FiIcons

const Footer=({promptData,onNavigate})=> {
const currentYear=new Date().getFullYear()

const handleQuickLinkClick=(section)=> {
// Scroll to top first
window.scrollTo({top: 0,behavior: 'smooth'})
// Navigate to the section
if (onNavigate) {
onNavigate(section)
} else {
// Fallback: try to navigate using hash
if (section.startsWith('#')) {
window.location.hash=section
}
}
}

const openGreta=()=> {
window.open('https://greta.quest','_blank','noopener,noreferrer')
}

const openLovable=()=> {
window.open('https://lovable.dev','_blank','noopener,noreferrer')
}

return (
<footer className="bg-slate-900 text-slate-300">
<div className="container mx-auto px-3 sm:px-4 py-6 sm:py-8">
{/* Main Footer Content */}
<div className="grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
{/* Brand Section */}
<div className="md:col-span-2">
<div className="flex items-center space-x-3 mb-3 sm:mb-4">
<img
src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751704966743-favicon.png"
alt="Promptly by RHT"
className="w-6 h-6 sm:w-8 sm:h-8 rounded-lg"
onError={(e)=> {e.target.style.display='none'}}
/>
<h3 className="text-lg sm:text-xl font-bold text-white">Promptly by RHT</h3>
</div>
<p className="text-slate-400 mb-3 sm:mb-4 max-w-md text-sm sm:text-base">
Craft perfect prompts for AI to save credits and get better results. Professional prompt builder with advanced features and smart recommendations.
</p>
<div className="flex items-center space-x-2 text-sm">
<span>Made with</span>
<SafeIcon icon={FiHeart} className="w-4 h-4 text-red-500" />
<span>by RHT Team</span>
</div>
</div>

{/* Quick Links */}
<div>
<h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Quick Links</h4>
<ul className="space-y-2">
<li>
<button
onClick={()=> handleQuickLinkClick('builder')}
className="text-slate-300 hover:text-white transition-colors text-left text-sm sm:text-base"
>
Prompt Builder
</button>
</li>
<li>
<button
onClick={()=> handleQuickLinkClick('categories')}
className="text-slate-300 hover:text-white transition-colors text-left text-sm sm:text-base"
>
Categories
</button>
</li>
<li>
<button
onClick={()=> handleQuickLinkClick('saved')}
className="text-slate-300 hover:text-white transition-colors text-left text-sm sm:text-base"
>
Saved Prompts
</button>
</li>
<li>
<button
onClick={()=> handleQuickLinkClick('settings')}
className="text-slate-300 hover:text-white transition-colors text-left text-sm sm:text-base"
>
Settings
</button>
</li>
</ul>
</div>

{/* Legal & Admin Links */}
<div>
<h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Legal & Support</h4>
<ul className="space-y-2">
{/* Privacy Policy Link - Footer Only */}
{promptData?.includePrivacyPage && (
<li>
<button
onClick={()=> handleQuickLinkClick('privacy')}
className="text-slate-300 hover:text-white transition-colors flex items-center space-x-1 text-left text-sm sm:text-base"
>
<SafeIcon icon={FiShield} className="w-3 h-3 sm:w-4 sm:h-4" />
<span>Privacy Policy</span>
</button>
</li>
)}

{/* Terms of Service Link - Footer Only */}
{promptData?.includeTermsPage && (
<li>
<button
onClick={()=> handleQuickLinkClick('terms')}
className="text-slate-300 hover:text-white transition-colors flex items-center space-x-1 text-left text-sm sm:text-base"
>
<SafeIcon icon={FiFileText} className="w-3 h-3 sm:w-4 sm:h-4" />
<span>Terms of Service</span>
</button>
</li>
)}

{/* Contact Page Link */}
{promptData?.includeContactPage && (
<li>
<button
onClick={()=> handleQuickLinkClick('contact')}
className="text-slate-300 hover:text-white transition-colors flex items-center space-x-1 text-left text-sm sm:text-base"
>
<SafeIcon icon={FiMail} className="w-3 h-3 sm:w-4 sm:h-4" />
<span>Contact Us</span>
</button>
</li>
)}

{/* Admin Console Link - Footer Only */}
{promptData?.includeAdminConsole && (
<li>
<button
onClick={()=> handleQuickLinkClick('admin')}
className="text-slate-300 hover:text-white transition-colors flex items-center space-x-1 text-left text-sm sm:text-base"
>
<SafeIcon icon={FiSettings} className="w-3 h-3 sm:w-4 sm:h-4" />
<span>Admin Console</span>
</button>
</li>
)}

<li>
<a
href="https://github.com/rht-labs"
target="_blank"
rel="noopener noreferrer"
className="text-slate-300 hover:text-white transition-colors flex items-center space-x-1 text-sm sm:text-base"
>
<SafeIcon icon={FiExternalLink} className="w-3 h-3 sm:w-4 sm:h-4" />
<span>GitHub</span>
</a>
</li>
</ul>
</div>
</div>

{/* AI Tools Section */}
<div className="border-t border-slate-700 pt-6 sm:pt-8 mb-6">
<div className="text-center">
<h4 className="text-white font-semibold mb-4 text-sm sm:text-base">Powered by AI Tools</h4>
<div className="flex flex-col sm:flex-row justify-center items-center space-y-3 sm:space-y-0 sm:space-x-4">
{/* Greta Button */}
<motion.button
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
onClick={openGreta}
className="flex items-center space-x-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl"
>
<SafeIcon icon={FiBot} className="w-4 h-4 sm:w-5 sm:h-5" />
<span className="text-sm sm:text-base">Open Greta</span>
<SafeIcon icon={FiExternalLink} className="w-3 h-3 sm:w-4 sm:h-4" />
</motion.button>

{/* Lovable Button */}
<motion.button
whileHover={{scale: 1.05}}
whileTap={{scale: 0.95}}
onClick={openLovable}
className="flex items-center space-x-2 bg-gradient-to-r from-pink-600 to-rose-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium hover:from-pink-700 hover:to-rose-700 transition-all shadow-lg hover:shadow-xl"
>
<SafeIcon icon={FiCode} className="w-4 h-4 sm:w-5 sm:h-5" />
<span className="text-sm sm:text-base">Open Lovable</span>
<SafeIcon icon={FiExternalLink} className="w-3 h-3 sm:w-4 sm:h-4" />
</motion.button>
</div>
<p className="text-xs sm:text-sm text-slate-400 mt-3">
AI-powered development tools for creating amazing applications
</p>
</div>
</div>

{/* Bottom Bar */}
<div className="border-t border-slate-700 pt-6 sm:pt-8">
<div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
<div className="text-xs sm:text-sm text-slate-400 text-center md:text-left">
© {currentYear} Promptly by RHT. All rights reserved.
</div>

{/* Connection Status */}
<div className="flex items-center space-x-2 sm:space-x-4">
{promptData?.connectToSupabase && (
<div className="flex items-center space-x-1 sm:space-x-2 text-xs">
<div className="w-2 h-2 bg-green-500 rounded-full"></div>
<span className="text-slate-400">Supabase Ready</span>
</div>
)}

{promptData?.connectToGithub && (
<div className="flex items-center space-x-1 sm:space-x-2 text-xs">
<div className="w-2 h-2 bg-blue-500 rounded-full"></div>
<span className="text-slate-400">GitHub Ready</span>
</div>
)}

{promptData?.isPwa && (
<div className="flex items-center space-x-1 sm:space-x-2 text-xs">
<div className="w-2 h-2 bg-purple-500 rounded-full"></div>
<span className="text-slate-400">PWA Enabled</span>
</div>
)}

{promptData?.includeAiChatbot && (
<div className="flex items-center space-x-1 sm:space-x-2 text-xs">
<div className="w-2 h-2 bg-cyan-500 rounded-full"></div>
<span className="text-slate-400">AI Chatbot</span>
</div>
)}
</div>
</div>
</div>
</div>
</footer>
)
}

export default Footer